"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.editAccreditedForm = void 0;
var Yup = __importStar(require("yup"));
exports.editAccreditedForm = Yup.object().shape({
    programId: Yup.string().required('Campo "Progroma" obrigatório'),
    CNPJ: Yup.string().required('Campo "CNPJ" obrigatório').min(14, 'O CNPJ deve ter 14 digitos').max(14),
    corporateReason: Yup.string().required('Campo "Razão corporativa" obrigatório'),
    fantasyName: Yup.string().required('Campo "Nome fantasia" obrigatório'),
    CEP: Yup.string().required('Campo "CEP" obrigatório'),
});
